import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Veuillez remplir tous les champs");
      return;
    }

    if (
      email !== process.env.REACT_APP_AUTH_EMAIL ||
      password !== process.env.REACT_APP_AUTH_PASSWORD
    ) {
      setError("Identifiants incorrects");
      return;
    }

    setIsLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      setError("Une erreur est survenue. Veuillez réessayer");
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ff9be4] to-[#ff6bd4] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        {/* Logo and title */}
        <div className="text-center mb-8">
          <img
            src="/logo.png"
            alt="Sur4Plots Logo"
            className="mx-auto h-20 w-20 rounded-full shadow-lg mb-6"
          />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Espace Administrateur
          </h2>
          <p className="text-sm text-gray-600">
            Connectez-vous pour accéder au tableau de bord
          </p>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-800 text-center">{error}</p>
          </div>
        )}

        {/* Login form */}
        <form onSubmit={login} className="space-y-5">
          <div>
            <label
              className="block text-sm font-medium text-gray-700 mb-2"
              htmlFor="email"
            >
              Adresse email
            </label>
            <input
              id="email"
              autoFocus
              type="email"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 text-base outline-none focus:border-[#ff9be4] focus:ring-2 focus:ring-[#ff9be4]/20 transition disabled:bg-gray-50 disabled:cursor-not-allowed"
              placeholder="nom@exemple.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              disabled={isLoading}
              required
            />
          </div>

          <div>
            <label
              className="block text-sm font-medium text-gray-700 mb-2"
              htmlFor="password"
            >
              Mot de passe
            </label>
            <input
              id="password"
              type="password"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 text-base outline-none focus:border-[#ff9be4] focus:ring-2 focus:ring-[#ff9be4]/20 transition disabled:bg-gray-50 disabled:cursor-not-allowed"
              placeholder="••••••••"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              disabled={isLoading}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-lg font-semibold text-white shadow-lg bg-[#ff9be4] hover:bg-[#ff6bd4] active:scale-[0.98] transition-all disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400 disabled:active:scale-100"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Connexion en cours...
              </span>
            ) : (
              "Se connecter"
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center">
            © {new Date().getFullYear()} MAGIC NONA. Tous droits réservés.
          </p>
        </div>
      </div>
    </div>
  );
}